import React, { useEffect } from "react";
import Secondary from "../buttons/secondary/Secondary";
import "./Contact.css";
import helpers from "../../_helpers/helpers";

const Contact = () => {
  return (
    <section className="contact" id="contact me">
      <div className="col-1">
        <h2 className="h2 contact__heading">
          Interested in building a project together?
        </h2>
      </div>
      <div className="col-2">
        <Secondary text={"contact me"} action={helpers.openContactDrawer} />
      </div>
    </section>
  );
};

export default Contact;
